<template>
  <div class="page-container" style="padding: 0 20px 20px">
    <a-page-header class="page-header" @back="handleBack">
      <div slot="title" style="cursor: pointer" @click="handleBack">
        返回
        <span v-for="(item, index) in titleList" :key="index">
          <span :style="{ color: index == titleList.length - 1 ? '#297ede' : '' }">{{ item }}</span>
          <span v-if="index < titleList.length - 1" style="padding: 0 2px">/</span>
        </span>
      </div>
    </a-page-header>
    <!--    viewRecord.tag为0时，显示活动详情详情，为1时，显示测评分析-->
    <a-tabs
      v-if="titleList?.length == 1 && viewRecord?.tag == '0'"
      v-model="activeKey"
      @change="handleTabChange"
    >
      <a-tab-pane v-for="item in tabList" :key="item.key" :tab="item.tab" />
    </a-tabs>
    <template v-if="activeKey == '0'">
      <template v-if="!Object.keys(classDetail).length">
        <a-row gutter="24">
          <a-col
            :span="24"
            :style="{ marginBottom: '20px', marginTop: viewRecord?.tag == '1' && '20px' }"
          >
            <span class="title-1">{{ viewRecord?.title }}</span>
            <j-dict-select-tag
              style="width: 150px; margin-left: 15px"
              placeholder="请选择年级"
              v-model="queryParam.gradeId"
              dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
              :optionalVals="viewRecord.gradeIds"
              :isShowEmpty="false"
              @select="$set(queryParam, 'classId', undefined)"
            />
            <j-dict-select-tag
              style="width: 150px; margin-left: 15px"
              placeholder="请选择班级"
              v-model="queryParam.classId"
              :dictCode="
                'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)
              "
              :optionalVals="viewRecord.classIds"
              :disabled="!queryParam.gradeId"
              :isShowEmpty="false"
            />
            <a-button type="primary" style="margin-left: 10px" @click="queryData">查询</a-button>
          </a-col>
        </a-row>
        <div class="scroll-box box-shadow-3">
          <a-row v-if="viewRecord?.tag == '0'" gutter="24">
            <a-col :span="12" style="margin-bottom: 20px">
              <div class="flex-between card-box">
                <div v-for="(item, index) in ciecleList" :key="index" class="progress-item">
                  <a-progress
                    type="circle"
                    :width="160"
                    :strokeColor="item.color"
                    :percent="item.rate"
                  >
                    <template #format="percent">
                      <div>
                        <div style="font-size: 24px; font-weight: bold">{{ percent }}%</div>
                        <div style="margin-top: 10px">{{ item.rateTitle }}</div>
                      </div>
                    </template>
                  </a-progress>
                  <div>
                    <div style="margin: -40px 0 40px 0">
                      <div class="num-value">{{ item.num1 }}</div>
                      <div>{{ item.label1 }}</div>
                    </div>
                    <div>
                      <div class="num-value">{{ item.num2 }}</div>
                      <div>{{ item.label2 }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </a-col>
            <a-col
              v-for="(pie, pIndex) in pieData"
              :key="pIndex"
              :span="12"
              style="margin-bottom: 20px"
            >
              <div class="flex-around-center card-box">
                <PieChart
                  style="width: 60%; height: 230px"
                  radius="55%"
                  :dataSource="pie"
                  :grid="grid"
                />
                <div class="text-card">
                  <div v-for="(item, index) in pie" :key="index">
                    <div class="flex-align-center">
                      <div>{{ item.name }}</div>
                      <div class="num-value" style="margin-left: 15px">
                        <CountAnimation :end-val="item.value || 0" />
                      </div>
                    </div>
                  </div>
                </div>
                <a-button class="assessment-btn" type="primary" size="small" @click="skipPage()">
                  评估
                </a-button>
              </div>
            </a-col>
          </a-row>
          <a-row v-else gutter="24">
            <a-col :span="24" style="margin-bottom: 20px">
              <div class="card-box">
                <div v-for="(item, index) in [ciecleList[0]]" :key="index" class="activities-item">
                  <a-progress
                    type="circle"
                    :width="160"
                    :strokeColor="item.color"
                    :percent="item.rate"
                  >
                    <template #format="percent">
                      <div>
                        <div style="font-size: 24px; font-weight: bold">{{ percent }}%</div>
                        <div style="margin-top: 10px">班级参与率</div>
                      </div>
                    </template>
                  </a-progress>
                  <div style="padding: 0 60px">
                    <div class="num-value" style="margin-bottom: 20px">
                      <CountAnimation :end-val="item.num1 || 0" />
                    </div>
                    <div>{{ item.label1 }}</div>
                  </div>
                  <div style="padding: 0 60px">
                    <div class="num-value" style="margin-bottom: 20px">
                      <CountAnimation :end-val="item.num2 || 0" />
                    </div>
                    <div>{{ item.label2 }}</div>
                  </div>
                </div>
              </div>
            </a-col>
          </a-row>
          <a-row class="card-box" style="margin-bottom: 10px">
            <a-col :span="24" class="flex-between">
              <div>*表格数据次日更新</div>
              <a-button type="primary" @click="handleExportXls('进度表')">导出进度条</a-button>
            </a-col>
            <a-col :span="24" class="flex-between">
              <TableList
                style="width: 100%; margin-top: 10px"
                :columns="columns[viewRecord?.tag]"
                :tableData="tableData"
                :loading="loading"
                :scroll="{}"
                :pagination="pagination"
                @change="handleTableChange"
              >
                <template #action="{ record }">
                  <span style="color: #1783e8; cursor: pointer" @click="viewProgress(record)">
                    查看进度
                  </span>
                </template>
              </TableList>
            </a-col>
          </a-row>
        </div>
      </template>
      <template v-else>
        <ClassCompleteDetail :viewRecord="viewRecord" :classDetail="classDetail" />
      </template>
    </template>
    <template v-if="activeKey == '1'">
      <ReportAnalysis :viewRecord="viewRecord" />
    </template>
  </div>
</template>

<script>
import PieChart from '@/components/echartZyz/components/PieChart'
import TableList from '@/components/chart/TableList'
import ClassCompleteDetail from '@/comUi/ClassCompleteDetail'
import ReportAnalysis from './components/ReportAnalysis'
import { getAction } from '@/api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import CountAnimation from '@/components/CountAnimation'

export default {
  name: 'PlanDetails',
  components: {
    PieChart,
    TableList,
    ClassCompleteDetail,
    ReportAnalysis,
    CountAnimation,
  },
  mixins: [JeecgListMixin],
  data() {
    return {
      titleList: ['工作台'],
      activeKey: '0',
      tabList: [
        {
          tab: '参与情况',
          key: '0',
        },
        {
          tab: '报告分析',
          key: '1',
        },
      ],
      queryParam: {},
      url: {
        list: '',
        exportXlsUrl: '',
      },
      ciecleList: [
        {
          color: '#1783E8',
          rate: 0,
          rateTitle: '班级参与率',
          label1: '已参与班级数',
          num1: 0,
          label2: '计划参与班级数',
          num2: 0,
        },
        {
          color: '#13B999',
          rate: 0,
          rateTitle: '测评完成率',
          label1: '已完成学生人数',
          num1: 0,
          label2: '计划完成学生人数',
          num2: 0,
        },
      ],
      grid: {
        top: '0%',
        bottom: '20%',
      },
      pieData: [
        // [
        //   { value: 100, name: '60分以下' },
        //   { value: 200, name: '61-70分' },
        //   { value: 320, name: '71-80分' },
        //   { value: 203, name: '81-90分' },
        //   { value: 50, name: '91-100分' },
        // ],
      ],
      columns: [
        [
          {
            title: '序号',
            dataIndex: 'index',
            align: 'center',
          },
          {
            title: '班级',
            dataIndex: 'className',
            align: 'center',
          },
          {
            title: '班主任',
            dataIndex: 'classTeacherName',
            align: 'center',
          },
          {
            title: '学生数量',
            dataIndex: 'planStudentNum',
            align: 'center',
          },
          {
            title: '已完成人数',
            dataIndex: 'finishStudentNum',
            align: 'center',
          },
          {
            title: '未完成人数',
            align: 'center',
            customRender: (_, record) => {
              return record.planStudentNum - record.finishStudentNum
            },
          },
          {
            title: '测评完成率',
            align: 'center',
            customRender: (_, record) => {
              return record.finishStudentNum
                ? ((record.finishStudentNum / record.planStudentNum) * 100).toFixed(2) + '%'
                : '0%'
            },
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            scopedSlots: { customRender: 'action' },
          },
        ],
        [
          {
            title: '序号',
            dataIndex: 'index',
            align: 'center',
          },
          {
            title: '班级',
            dataIndex: 'className',
            align: 'center',
          },
          {
            title: '班主任',
            dataIndex: 'classTeacherName',
            align: 'center',
          },
          {
            title: '状态',
            dataIndex: 'status',
            align: 'center',
            customRender: (_, record) => {
              return (
                <div style={{ color: record.status == 1 ? '#1890FF' : '' }}>
                  {record.status == 1 ? '已完成' : '未完成'}
                </div>
              )
            },
          },
        ],
      ],
      tableData: [],
      disableMixinCreated: true,
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '50'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        // showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      classDetail: {},
    }
  },
  created() {
    console.log('历史记录--', this.$router)
    this.viewRecord = this.$router.history.current.query
    this.$set(this.queryParam, 'planId', this.viewRecord?.id)
    this.$set(
      this.url,
      'exportXlsUrl',
      this.viewRecord.tag == '0'
        ? '/schoolEvaluationPlan/classCompletionProgressExport'
        : '/schoolActivityPlanResult/exportXls'
    )
    if (this.viewRecord?.pageName) {
      this.titleList = [this.viewRecord.pageName]
    }
    this.getPlanDetails()
    this.loadData()
  },
  methods: {
    getPlanDetails() {
      const params = {
        planId: this.viewRecord?.id,
        ...this.queryParam,
      }
      // 整体圆环图
      getAction('/schoolEvaluationPlan/completionProgress', params).then((res) => {
        if (res.success) {
          const { planClassNum, finishClassNum, planStudentNum, finishStudentNum } = res.result
          this.$set(this.ciecleList, 0, {
            ...this.ciecleList[0],
            rate: finishClassNum ? ((finishClassNum / planClassNum) * 100).toFixed(2) : 0,
            num1: finishClassNum,
            num2: planClassNum,
          })
          if (this.viewRecord?.tag == 1) return
          this.$set(this.ciecleList, 1, {
            ...this.ciecleList[1],
            rate: finishStudentNum ? ((finishStudentNum / planStudentNum) * 100).toFixed(2) : 0,
            num1: finishStudentNum,
            num2: planStudentNum,
          })
        }
      })
      // 量表饼图
      getAction('/schoolEvaluationPlan/pointStudentDistribution', params).then((res) => {
        if (res.success) {
          this.pieData = res.result?.map((item) => item.chartData)
        }
      })
    },
    loadData() {
      const baseParams = {
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
      }
      const url =
        this.viewRecord?.tag == '0'
          ? '/schoolEvaluationPlan/classCompletionProgress'
          : '/schoolActivityPlanResult/list'
      getAction(url, {
        ...baseParams,
        ...this.queryParam,
        planId: this.viewRecord?.id,
      }).then((res) => {
        this.tableData = res.result.records?.map((item, index) => ({
          ...item,
          index: index + 1,
        }))
        this.$set(this.pagination, 'total', res.result.total)
      })
    },
    queryData() {
      this.getPlanDetails()
      this.loadData()
    },
    handleBack() {
      console.log('记录信息：', this.viewRecord)
      if (Object.keys(this.classDetail).length > 1) {
        this.titleList.pop()
        this.classDetail = {}
        return
      }
      this.viewRecord?.pagePath
        ? this.$router.push({
            path: this.viewRecord.pagePath,
            query: {
              tabKey: this.viewRecord.tabKey,
            },
          })
        : this.$router.go(-1)
    },
    skipPage() {
      this.$router.push({
        path: '/school/mentalHealth/MindEvaluation',
        query:{
          tabKey:3
        }
      })
    },
    // 分页变化
    handleTableChange(page) {
      this.pagination = page
      this.loadData()
    },
    viewProgress(record) {
      console.log('查看进度条--', record)
      this.classDetail = record
      this.titleList.push(record.className)
    },
    handleTabChange(key) {},
  },
}
</script>
<style scoped lang="less">
.page-header {
  padding-left: 0;
  border-bottom: 1px solid #eee;

  /deep/ .ant-page-header-heading-title {
    font-size: 14px;
  }
}

.progress-item {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 35px;
  flex: 1;
}

.activities-item {
  display: flex;
  align-items: center;
  padding: 30px;
  flex: 1;
}

.scroll-box {
  max-height: 80vh;
  padding: 10px;
  border-radius: 10px;
  overflow-y: auto;
  overflow-x: hidden;
}

.card-box {
  position: relative;
  border: 1px solid #e8e8e8;
  border-radius: 5px;
  padding: 20px;

  .num-value {
    font-size: 28px;
    font-weight: bold;
  }

  .text-card {
    flex: 1;
    height: 210px;
    padding: 0 10px;
    margin-top: 22px;
    overflow: hidden;
    overflow-y: auto;
    border-radius: 4px;
  }

  .assessment-btn {
    position: absolute;
    top: 10px;
    right: 15px;
  }
}
</style>
